// 会员中心图片验证码类型枚举
export const REGISTER = "1";//注册
export const LOGIN = "2";//手机动态码登录
export const BIND_POLICY = "5";//绑定保单
export const BIND_WECHAT = "6";//微信绑定
